import React from 'react'

const loadingStyle = {
  margin: 0,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translateY(-50%)"
}

const loadingImageStyle = {
  maxWidth: "100%",
  maxHeight: "2rem",
  alignSelf: "center"
}

export default function Loading() {
  return (
    <div className="d-flex flex-column align-self-center m-auto" style={loadingStyle}>
      <img alt="loading" style={loadingImageStyle} src='/icons/loading-transparent.jpg'/>
    </div>
  )
}